import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthActions } from './modules/login/store/auth.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'SGC-Front';
  private unsubscriber$ = new Subject<void>();

  constructor(
    private store: Store,
  ) {}

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.store.dispatch(new AuthActions.SetDefaultState());
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}

